import { library, dom } from "@fortawesome/fontawesome-svg-core";

import { 
    faComment,
    faRetweet,
    faHeart,
    faSearch,
    faWindowClose,
    faCalendarAlt,
    faHandPointRight,
    faHourglassHalf,
    faDotCircle
} from "@fortawesome/pro-regular-svg-icons";

import {
    faChevronRight,
    faChevronLeft,
    faChevronDown,
    faChevronUp,
    faUser,
    faUsers,
    faBuilding,
    faVideo,
    faCircleNotch,
    faSpinner,
    faComments,
    faChartBar,
    faForward,
    faBackward,
    faStepForward,
    faStepBackward,
    faSort,
    faSortUp,
    faSortDown,
    faClock,
    faTrash,
    faTimes
} from "@fortawesome/pro-solid-svg-icons";

import { 
    faTwitter,
    faLinkedin,
    faGithub
} from '@fortawesome/free-brands-svg-icons';

library.add(
    faComment,
    faRetweet,
    faHeart,
    faChevronRight,
    faChevronLeft,
    faChevronUp,
    faChevronDown,
    faTwitter,
    faLinkedin,
    faGithub,
    faUser,
    faUsers,
    faBuilding,
    faVideo,
    faCircleNotch,
    faSpinner,
    faSearch,
    faWindowClose,
    faCalendarAlt,
    faHandPointRight,
    faComments,
    faChartBar,
    faHourglassHalf,
    faForward,
    faBackward,
    faStepForward,
    faStepBackward,
    faSort,
    faSortUp,
    faSortDown,
    faClock,
    faDotCircle,
    faTrash,
    faTimes
);

dom.watch();
